<div class="modal-header">
	<h4 class="modal-title">{{'labels.dochistory' | translate}}</h4>
	<button
		type="button"
		class="close"
		aria-label="Close"
		(click)="dismiss()">
		<span aria-hidden="true">×</span>
	</button>
</div>
<div
	class="modal-body"
	ngbAutofocus>
	<div
		class="row"
		*ngIf="loading">
		<div class="col text-center">
			<app-loader [material]="false"></app-loader>
		</div>
	</div>

	<ngx-datatable
		*ngIf="!loading"
		#datatable2
		class="{{bootstrap ? 'bootstrap' : 'material'}}"
		[rows]="rows"
		[columnMode]="'flex'"
		[rowHeight]="'auto'"
		[headerHeight]="50"
		[footerHeight]="50"
		[loadingIndicator]="loading"
		[messages]="{
          emptyMessage: 'labels.empty-attachments' | translate,
          totalMessage: 'labels.total' | translate
        }">

		<ngx-datatable-column
			prop="id"
			[flexGrow]="0.5"
			[name]="'labels.id' | translate"
			*ngIf="!hideid">
			<ng-template
				let-value="value"
				let-row="row"
				ngx-datatable-cell-template>
				{{value}}
			</ng-template>
		</ngx-datatable-column>

		<ngx-datatable-column [flexGrow]="1">
			<ng-template
				let-value="value"
				let-row="row"
				ngx-datatable-cell-template>

				<div>

					<i
						*ngIf="row.mandatory"
						[ngbTooltip]="('labels.mandatory' | translate) + ' - ' + ((!row ? 'labels.missing' : 'labels.present') | translate )"
						class="fas fa-asterisk"
						[ngClass]="{'invalid': !row}"></i>

					<i
						class="fas fa-clock"
						*ngIf="row.expirable"
						[ngbTooltip]="('labels.expirable' | translate) +   (!row ? '' : ( ' - '  + (( !row.expirydate || row.expirydate < today ? 'labels.expired' : 'labels.valid') | translate)))"
						[ngClass]="{'invalid': !row || !row.expirydate ||  row.expirydate < today}"></i>

				</div>

			</ng-template>
		</ngx-datatable-column>

		<ngx-datatable-column
			prop="filename"
			[flexGrow]="4"
			[name]="'labels.filename' | translate">
			<ng-template
				let-row="row"
				let-value="value"
				ngx-datatable-cell-template>
				{{row?.filename}}fff
				<el-attachment-preview
					[attach]="row"
					mediapath="download"></el-attachment-preview>

			</ng-template>
		</ngx-datatable-column>

		<ngx-datatable-column
			prop="size"
			[flexGrow]="1.5"
			[name]="'labels.size' | translate">
			<ng-template
				let-row="row"
				let-value="value"
				ngx-datatable-cell-template>
				{{row?.size | fileSize }}
			</ng-template>
		</ngx-datatable-column>

		<ngx-datatable-column
			prop="uploaddate"
			[flexGrow]="2"
			[name]="'labels.uploaddate' | translate">
			<ng-template
				let-row="row"
				let-value="value"
				ngx-datatable-cell-template>
				{{ row?.uploaddate | date:'dd/MM/yyyy HH:mm'}}
			</ng-template>
		</ngx-datatable-column>

		<ngx-datatable-column
			[flexGrow]="1"
			[sortable]="false">
			<ng-template
				let-value="value"
				let-row="row"
				ngx-datatable-cell-template>
				<div class="icon-buttons">
					<el-attachment-download
						[attach]="row"
						[bootstrap]="true"
						mediapath="download"></el-attachment-download>
					<a
						[ngbTooltip]="'labels.delete' | translate"
						*ngIf="isAdmin"
						(click)="delete(row)">

						<i
							*ngIf="!bootstrap"
							class="mdi mdi-18px mdi-delete"></i>
						<i
							*ngIf="bootstrap"
							class="fa fa-trash"></i>
					</a>
				</div>
			</ng-template>
		</ngx-datatable-column>

	</ngx-datatable>

	<div
		class="row"
		*ngIf="!loading">
		<div class="col-sm-12"></div>
	</div>
</div>
<div class="modal-footer">
	<button
		type="button"
		class="btn btn-secondary"
		(click)="dismiss()">
		{{'labels.close' | translate}}
	</button>
</div>
